import React from "react";

import { Navigate, createFileRoute } from "@tanstack/react-router";

import { Queries } from "@/queries/Queries.ts";
import { PatientSyncTemplate } from "@/uiKit/templates/PatientSyncTemplate.tsx";

const PatientSyncRouteGuard: React.FC = () => {
  const me = Queries.user.usePractitionerMe({});
  if (me.qualification !== "doctor") {
    return <Navigate to="/patients" />;
  }
  return <PatientSyncTemplate />;
};

export const Route = createFileRoute("/_practitioner/patient-sync")({
  component: PatientSyncRouteGuard,
});
